import { render, staticRenderFns } from "./TestPrepRenderer.vue?vue&type=template&id=63ba51d8&"
import script from "./TestPrepRenderer.vue?vue&type=script&lang=js&"
export * from "./TestPrepRenderer.vue?vue&type=script&lang=js&"
import style0 from "./TestPrepRenderer.vue?vue&type=style&index=0&id=63ba51d8&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports